'use strict';

import LoadingService from './loading-service.js';

export default {
    install(VueInstance) {
        VueInstance.prototype.$loader = VueInstance.$loader = LoadingService;
    }
};
